import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';

@Component({
	selector: 'app-toggle-all',
	templateUrl: './toggle-all.component.html',
	styleUrls: ['./toggle-all.component.scss']
})
export class ToggleAllComponent {
	@Input() public checkboxes: any;
	@Input() public checkboxesFormGroup: UntypedFormGroup;

	constructor() {
	}

	isChecked(): any {
		if (!this.checkboxes || this.checkboxes.length === 0) {
			return false;
		}
		return this.checkboxes?.filter((checkbox: MatCheckbox) => checkbox.checked)?.length === this.checkboxes?.length;
	}

	isIndeterminate(): any {
		if (!this.checkboxes || this.checkboxes.length === 0) {
			return false;
		}
		return this.checkboxes?.filter((checkbox: MatCheckbox) => checkbox.checked)?.length > 0 && !this.isChecked();
	}

	toggleAll(event: MatCheckboxChange) {
		Object.keys(this.checkboxesFormGroup.controls).forEach(key => {
			this.checkboxesFormGroup.controls[key].setValue(event.checked);
			this.checkboxesFormGroup.controls[key].markAsDirty();
		});
	}

}
